<template>
    <entrance-page-layout :top-bar="true" v-once>
        <box-content-message>
            <template v-slot:icon>
                <img src="@/assets/gifs/airplane.gif"
                     alt="bird"
                     width="160"
                     height="160"
                >
            </template>
            <template v-slot:primaryText>
                <div>Help is on the way</div>
            </template>
            <template v-slot:secondaryText>
                <div class="emailText">
                    We sent an email to <span class="webBodyStrong">{{ email }}</span> <br/>
                with a link to reset your password.</div>
            </template>
        </box-content-message>
    </entrance-page-layout>
</template>

<script>
import BoxContentMessage from '@/pages/entrance/components/BoxContentMessageLayout.vue';
import EntrancePageLayout from '@/pages/entrance/components/EntrancePageLayout.vue';

export default {
    name: 'HelpIsOnTheWayPage',
    components: {
        EntrancePageLayout,
        BoxContentMessage
    },
    computed: {
        email() {
            return this.$route.query.email;
        }
    }
};
</script>

<style lang="scss" scoped>
@import "~styles/styleGuide.V2";

.emailText {
    color: $dark-300;
    padding-right: $spacing-xl;
    padding-left: $spacing-xl;
    transform: translateY($spacing-xl);
}
</style>
